// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.PROD 
    ? 'https://pipedream-mcp-api.aaronbaker.workers.dev' 
    : 'http://localhost:8787');

export const API_ENDPOINTS = {
  // Auth endpoints
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    logout: `${API_BASE_URL}/api/auth/logout`,
    me: `${API_BASE_URL}/api/auth/me`,
    refresh: `${API_BASE_URL}/api/auth/refresh`,
    callback: `${API_BASE_URL}/api/auth/callback`,
  },
  // Apps endpoints
  apps: {
    list: `${API_BASE_URL}/api/apps`,
    get: (id: string) => `${API_BASE_URL}/api/apps/${id}`,
    search: `${API_BASE_URL}/api/apps/search`,
  },
  // Connections endpoints
  connections: {
    list: `${API_BASE_URL}/api/connections`,
    get: (id: string) => `${API_BASE_URL}/api/connections/${id}`,
    create: `${API_BASE_URL}/api/connections`,
    delete: (id: string) => `${API_BASE_URL}/api/connections/${id}`,
  },
  // OAuth endpoints
  oauth: {
    authorize: `${API_BASE_URL}/api/oauth/authorize`,
    callback: `${API_BASE_URL}/api/oauth/callback`,
    status: (flowId: string) => `${API_BASE_URL}/api/oauth/flows/${flowId}`,
  },
  // Config endpoints
  config: {
    generate: `${API_BASE_URL}/api/config/generate`,
    validate: `${API_BASE_URL}/api/config/validate`,
    templates: `${API_BASE_URL}/api/config/templates`,
  },
  // Analytics endpoints
  analytics: {
    metrics: `${API_BASE_URL}/api/analytics/metrics`,
    activity: `${API_BASE_URL}/api/analytics/activity`,
    health: `${API_BASE_URL}/api/analytics/health`,
  },
  // Health check
  health: `${API_BASE_URL}/health`,
};

export const getApiUrl = (endpoint: string): string => {
  if (endpoint.startsWith('http')) {
    return endpoint;
  }
  return `${API_BASE_URL}${endpoint}`;
};